/**
 * Migration silencieuse des clés `localStorage` historiques `maestro.*` vers
 * leur équivalent `sentinelle.*` (renommage produit — Sentinelle DSS). Toutes
 * les clés de préférences/session sont passées de l'un à l'autre ; ce module
 * évite de perdre les réglages déjà enregistrés dans le navigateur d'un poste.
 *
 * Lecture : la nouvelle clé si elle existe, sinon l'ancienne — auto-migrée
 * (copiée sous la nouvelle clé, l'ancienne supprimée) pour ne plus jamais
 * retomber dessus ensuite. Best-effort : ne lève jamais (mode privé, quota,
 * jsdom sans persistance) — un échec de lecture/écriture retombe simplement
 * sur « rien de stocké ».
 */

const LEGACY_PREFIX = "maestro.";
const CURRENT_PREFIX = "sentinelle.";

/** Dérive la clé historique `maestro.*` d'une clé `sentinelle.*` (même suffixe). */
export function legacyKeyOf(key: string): string {
  return key.startsWith(CURRENT_PREFIX) ? `${LEGACY_PREFIX}${key.slice(CURRENT_PREFIX.length)}` : key;
}

export function readWithLegacyFallback(key: string, legacyKey: string): string | null {
  try {
    const current = localStorage.getItem(key);
    if (current !== null) return current;
    const legacy = localStorage.getItem(legacyKey);
    if (legacy === null) return null;
    try {
      localStorage.setItem(key, legacy);
      localStorage.removeItem(legacyKey);
    } catch {
      /* migration best-effort : la valeur legacy est quand même rendue ci-dessous */
    }
    return legacy;
  } catch {
    return null;
  }
}
